import React, { useState } from "react";
import { Button, Col, FormLabel, Row, Table } from "react-bootstrap";
import { AppContext } from "../AppContext.js";
import { ConfigManager } from "../config/ConfigManager.js";
import { BaseBean, RestReportBean } from "../ds/client_ds.js";
import {
  CustomerSalesOnOrderSearchCriteria,
  FabricStyleSearchCriteria,
  FabricStyleSKUBean,
  FabricStyleWeeklyMonthlyATSInquiryCriteriaBean,
  FabricStyleWeeklyMonthlyATSResultRequest,
  RestFabricStyleListBeanRequest,
  RestPageListBean,
  RestReadRequest,
  VendorPurchaseOnOrderSearchCriteria,
} from "../ds/ds.js";
import { DropDwnDown, DropDwnUp } from "../gui_components/Icons.js";
import {
  AlertToolBox,
  InputTextbox,
  MultiViewPopup,
  NumberFormatInputbox,
  ProgressBar,
  ShowError,
} from "../gui_components/UIComponents.js";
import {
  isEmpty,
  isEmptyArray,
  isEmptyString,
  toCommaSeperatedAmount
} from "../gui_components/Util.js";
import { FabricStyleLookupHandler } from "../lookup/FabricStyleLookupHandler.js";
import { GenericAttributeLookupHandler } from "../lookup/GenericAttributeLookupHandler.js";
import { BaseInquiryToolBar } from "../modules/BaseModule.js";
import {
  PopupCustomerModule,
  PopupFabricStyleModule,
  PopupPurchaseOrderModule,
  PopupSalesModule,
  PopupVendorModule,
} from "../modules/ModuleUtil.js";
import { SecurityAccessManager } from "../security/SecurityAccessManager.js";
import { CustomerService } from "../services/CustomerService.js";
import { FabricStyleService } from "../services/FabricStyleService.js";
import { ReportService } from "../services/ReportService.js";
import { VendorService } from "../services/VendorService";
class FabricWeeklyInquiryModule extends React.Component {
  static contextType = AppContext;
  constructor(props) {
    super(props);
    this.state = {
      onHandQtyDataList: [],
      pageTitle: "",
      isShowExecuteButton: true,
      isShowClearCriteriaButton: true,
      isShowResetButton: false,
      isShowPDFButton: false,
      isShowExcelButton: false,
      isShowExitButton: true,
      error_list: [],
      inquiryDataList: [],
      criteria: new FabricStyleWeeklyMonthlyATSInquiryCriteriaBean(),
      pageList: new RestPageListBean(),
      isInquiryDatasFound: false,
      isShowAlert: false,
      alertMsg: "",
      success_list: [],
      isShowFabricStyleModule: false,
      moduleForPopup: [],
      colorLookupHandler: null,
      isShowVendorQtyPopup: false,
      isShowCustomerQtyPopup: false,
      vendorQtyList: [],
      customerQtyList: [],
      vendorData: null,
      customerData: null,
      isShowCustomerModule: false,
      isShowVendorModule: false,
      isShowSalesModule: false,
      isShowPurchaseOrderModule: false,
      fabricColourPageListForAutoCompleteList: new Array(),
      fabricPageListForAutoCompleteList: new Array(),
      showAutoCompleteFabricList: true,
      showAutoCompleteFabricColorList: true,
      isShowProgressBarPopup: false,
      progressLoadingText: "",
      isDisable: false,
      isFabricLookup: true,
      order: "asc",
      sortField: "",
      is3PL: false,
    };
    this.fabricCodeRef = React.createRef();
    this.colorCodeRef = React.createRef();
  }
  componentDidMount() {
    const { appData } = this.context;
    this.companyCode = appData.companyCode;
    if (ConfigManager.isPurchaseBasedOnCustomerFlag()) {
      this.state.is3PL = true;
      this.setState({
        is3PL: true,
      });
    }
    if (this.state.is3PL === true) {
      this.state.pageTitle = "Item Weekly Monthly ATS-Inquiry";
    } else {
      this.state.pageTitle = "Fabric Weekly Monthly ATS-Inquiry";
    }
    this.report_url = appData.reportURL;
    this.initLookupHandlers();
  }
  initLookupHandlers = () => {
    let fabricLookupHandler = new FabricStyleLookupHandler(
      this.companyCode,
      this.state.is3PL ? "Item" : "Fabric Style"
    );
    this.setState({ fabricLookupHandler: fabricLookupHandler });
  };
  onChange = (e) => {
    let criteria = this.state.criteria;
    criteria[e.target.name] = e.target.value;
    this.setState({ criteria: criteria });
  };
  showErrorMessage = (response) => {
    if (response.errors != null) {
      let errMsg = "";
      let errList = [];
      response.errors.map(
        (err) => (
          (errMsg = errMsg + err.messageDescription),
          errList.push(err.messageDescription)
        )
      );
      this.setState({ error_list: errList });
      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
    }
  };
  showInfoMessage = (response) => {
    if (response.infos != null) {
      let infoMsg = "";
      let successList = this.state.success_list;
      response.infos.map(
        (info) => (
          (infoMsg = infoMsg + info.messageDescription),
          successList.push(info.messageDescription)
        )
      );
      this.setState({
        alertMessage: successList,
        alertType: "success",
        isShowAlert: true,
      });
    }
  };
  inValidAccess = (type) => {
    let errMsg = "Access Denied";
    if (type == 1) {
      errMsg = "Access Denied";
    } else if (type == 2) {
      errMsg = "PDF Access Denied";
    } else if (type == 3) {
      errMsg = "EXCEL Access Denied";
    } else if (type == 4) {
      errMsg = "Mail Access Denied";
    }
    let errList = [];
    errList.push(errMsg);
    this.setState({
      alertMessage: errList,
      alertType: "danger",
      isShowAlert: true,
      isShowProgressBarPopup: false,
      progressLoadingText: "",
    });
  };
  disable = () => {
    this.setState({
      isDisableFields: true,
    });
  };
  loadPage = () => {
    let criteria = this.state.criteria;
    criteria.companyCode = this.companyCode;
    if (!isEmptyString(criteria.fabricStyleCode)) {
      this.loadFabricWeeklyAtsInquiryList(criteria);
      this.setState({
        isShowProgressBarPopup: true,
        progressLoadingText: "Executing...",
      });
    } else {
      let errMsg = "";
      if (!this.state.is3PL) {
        errMsg = "FabricCode is Required";
      } else {
        errMsg = "ItemCode is Required";
      }
      let errList = [];
      errList.push(errMsg);
      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
        isShowProgressBarPopup: false,
        progressLoadingText: "",
      });
    }
  };
  loadFabricWeeklyAtsInquiryList = (listRequest) => {
    if (SecurityAccessManager.FabricWeeklyMonthlyATSInquiry_IsAccessible()) {
      ReportService.inquireFabricStyleWeeklyMonthlyATSResults(
        listRequest,
        this.loadFabricWeeklyAtsPageResponse,
        this.errorCallBack
      );
    } else {
      this.inValidAccess(1);
    }
  };
  loadFabricWeeklyAtsPageResponse = (response) => {
    this.showErrorMessage(response.data);

    if (!isEmpty(response.data) && !isEmpty(response.data.resultBean)) {
      let resultList = new Array();
      if (!isEmptyArray(response.data.resultBean.atsInfos)) {
        resultList = response.data.resultBean.atsInfos;
        this.setState({
          isShowExcelButton: true,
          isShowPDFButton: true,
        });
      }
      this.setState({
        isInquiryDatasFound: true,
        inquiryDataList: resultList,
        isShowResetButton: true,
        isShowClearCriteriaButton: false,
        isDisable: true,
        isFabricLookup: false,
        isShowColorLookup: false,
      });
    }
    this.setState({
      isShowProgressBarPopup: false,
      progressLoadingText: "",
    });
  };
  errorCallBack = (error) => {
    this.setState({
      isShowProgressBarPopup: false,
      progressLoadingText: "",
    });
    ShowError("Error : " + error);
  };
  execute = () => {
    this.hideAlertCallBack();
    this.loadPage(1);
  };
  clearError = () => {
    this.setState({ error_list: [] });
  };
  hideAlertCallBack = (msgType, isDisplayed) => {
    this.setState({ isShowAlert: isDisplayed, error_list: [] });
  };
  clearCriteria = () => {
    let criteria = new FabricStyleWeeklyMonthlyATSInquiryCriteriaBean();
    criteria.companyCode = this.companyCode;
    criteria.fabricStyleName = "";
    this.setState({
      criteria: criteria,
      isShowColorLookup: false,
    });
    this.hideAlertCallBack();
  };
  resetInquiry = () => {
    let criteria = new FabricStyleWeeklyMonthlyATSInquiryCriteriaBean();
    criteria.companyCode = this.companyCode;
    criteria.fabricStyleName = "";
    this.setState({
      criteria: criteria,
      isInquiryDatasFound: false,
      inquiryDataList: new Array(),
      isShowPDFButton: false,
      isShowResetButton: false,
      isShowExcelButton: false,
      isShowColorLookup: false,
      isShowClearCriteriaButton: true,
      isDisable: false,
      isFabricLookup: true,
    });
    this.hideAlertCallBack();
  };
  fabricCodeOnChange = (e) => {
    let fabricStyleCode = e.target.value;
    this.state.showAutoCompleteFabricList = true;
    let tempCriteria = this.state.criteria;
    let showAutoCompleteList = this.state.showAutoCompleteFabricList;
    if (isEmpty(fabricStyleCode)) {
      this.state.showAutoCompleteFabricList = false;
      let showAutoCompleteList = this.state.showAutoCompleteFabricList;
      let criteria = this.state.criteria;
      criteria.fabricStyleCode = "";
      criteria.fabricStyleName = "";
      criteria.fabricStyleColorCode = "";
      let suggestion = [];
      this.setState({
        showAutoCompleteList: showAutoCompleteList,
        criteria: criteria,
        fabricColourPageListForAutoCompleteList: suggestion,
        fabricColourPageListForAutoCompleteList: suggestion,
        isShowColorLookup: false,
        colorList: [],
      });
    } else if (
      e.target.name == "fabricStyleCode" &&
      showAutoCompleteList === true &&
      fabricStyleCode !== ""
    ) {
      this.readFabricBySearchString(e.target.value);
    }
    tempCriteria[e.target.name] = e.target.value;
    this.setState({ criteria: tempCriteria });
  };
  readandsetFabricStyleDetailResponse = (response) => {
    let criteria = this.state.criteria;
    if (response.data != null && response.data.fabricStyle != null) {
      let fabricStyle = response.data.fabricStyle;
      if (!isEmpty(fabricStyle)) {
        criteria.fabricStyleCode = fabricStyle.code;
        criteria.fabricStyleName = fabricStyle.description;
        let colors = fabricStyle.colors;
        let finalColorList = [];
        colors.map((ent) => {
          let colorBean = new BaseBean();
          colorBean.code = ent.fabricStyleColorCode;
          colorBean.description = ent.fabricStyleColorName;
          finalColorList.push(colorBean);
        });
        this.setState({ colorLookupHandler: null });
        if (finalColorList != null) {
          let colorLookupHandler = new GenericAttributeLookupHandler(
            finalColorList,
            "Color"
          );
          this.setState({
            colorLookupHandler: colorLookupHandler,
            isShowColorLookup: true,
            criteria: criteria,
            colorList: finalColorList,
            fabricStyleData: fabricStyle,
            isShowProgressBarPopup: false,
            progressLoadingText: "",
          });
        }
      }
    }
    this.setState({
      isShowProgressBarPopup: false,
      progressLoadingText: "",
    });
  };
  readandsetFabricStyleDetail = (fabricStyleCode) => {
    let input = new RestReadRequest();
    input.companyCode = this.companyCode;
    input.code = fabricStyleCode;
    input.isLoadChildren = true;
    FabricStyleService.readFabricStyle(
      input,
      this.readandsetFabricStyleDetailResponse,
      this.errorCallBack
    );
  };
  readFabricBySearchString(searchString) {
    let searchCriteria = new FabricStyleSearchCriteria();
    searchCriteria.companyCode = this.companyCode;
    searchCriteria.fabricStyleCodeStartsWith = searchString;
    searchCriteria.fabricStyleNameStartsWith = searchString;
    let pageList = new RestPageListBean();
    pageList.pageSize = 100;
    let input = new RestFabricStyleListBeanRequest();
    input.companyCode = this.companyCode;
    input.pageInput = pageList;
    input.code = searchString;
    input.searchCriteria = searchCriteria;
    FabricStyleService.getActiveFabricStylesForAutoComplete(
      input,
      this.readByFabricCodeResponse,
      this.errorCallBack
    );
  }
  readByFabricCodeResponse = (response) => {
    let fabricStyleData = response.data.fabricStylePageList.fabricStyles;
    let simpleAutoCompleteList = new Array();
    if (fabricStyleData.length > 0 && fabricStyleData != null) {
      fabricStyleData.map((fabricStyle) => {
        let simpleItemBean = {
          code: fabricStyle.fabricStyleCode,
          description: fabricStyle.fabricStyleName,
        };
        simpleAutoCompleteList.push(simpleItemBean);
      });
    }
    this.setState({
      fabricPageListForAutoCompleteList: simpleAutoCompleteList,
    });
  };
  fabricEnterKeyEventHandler = (e) => {
    let fabricStyleCode = e.target.value;
    this.readandsetFabricStyleDetail(fabricStyleCode);
    this.setState({
      isShowProgressBarPopup: true,
      progressLoadingText: this.state.is3PL
        ? "read Item"
        : "Reading FabricStyle",
    });
    this.setState({ fabricPageListForAutoCompleteList: new Array() });
  };
  displayAutoCompleteFabricList = (showAutoCompleteList) => {
    this.setState({ showAutoCompleteFabricList: showAutoCompleteList });
  };
  onFabricColourCodeChange = (e) => {
    this.state.showAutoCompleteFabricColorList = true;
    let colorCode = e.target.value;
    let showAutoCompleteFabricColorList =
      this.state.showAutoCompleteFabricColorList;
    if (isEmpty(colorCode)) {
      this.state.showAutoCompleteFabricColorList = false;
      let showAutoCompleteFabricColorList =
        this.state.showAutoCompleteFabricColorList;
      let criteria = this.state.criteria;
      criteria.fabricStyleColorCode = "";
      let suggestion = [];
      this.setState({
        showAutoCompleteFabricColorList: showAutoCompleteFabricColorList,
        criteria: criteria,
        fabricColourPageListForAutoCompleteList: suggestion,
      });
    } else if (
      e.target.name == "fabricStyleColorCode" &&
      showAutoCompleteFabricColorList === true &&
      colorCode !== ""
    ) {
      this.readFabricColourBySearchString(e.target.value);
    }
  };
  readFabricColourBySearchString(searchString) {
    let fabricStyle = this.state.fabricStyleData;
    let criteria = this.state.criteria;
    criteria.fabricStyleColorCode = searchString;
    let colorList = this.state.colorList;
    let simpleAutoCompleteColorList = new Array();
    colorList.map((colorListData) => {
      let simpleColorBean = {
        code: colorListData.code,
        description: colorListData.description,
      };
      simpleAutoCompleteColorList.push(simpleColorBean);
    });
    let userInput = searchString;
    let filteredSuggestions = new Array();
    filteredSuggestions = simpleAutoCompleteColorList.filter(
      (simpleAutoCompleteColorLists) =>
        simpleAutoCompleteColorLists.code
          .toLowerCase()
          .indexOf(userInput.toLowerCase()) > -1
    );
    this.setState({
      fabricColourPageListForAutoCompleteList: filteredSuggestions,
    });
  }
  fabricColourEnterKeyEventHandler = (e) => {
    let fabricStyleColourCode = e.target.value;
    this.fabricStyleColorSelected(fabricStyleColourCode);
    this.setState({ fabricColourPageListForAutoCompleteList: new Array() });
  };
  displayAutoCompleteFabricColorList = (showAutoCompleteList) => {
    this.setState({ showAutoCompleteFabricColorList: showAutoCompleteList });
  };
  fabricStyleColorSelected = (colorCode) => {
    let fabricStyle = this.state.fabricStyleData;
    let criteria = this.state.criteria;
    let skuBean = new FabricStyleSKUBean();
    fabricStyle.fabricStyleSkus.map((sku) => {
      if (
        sku.fabricStyleCode == criteria.fabricStyleCode &&
        sku.fabricStyleColorCode == colorCode
      )
        skuBean = sku;
    });
    criteria.fabricStyleColorCode = colorCode;
    this.setState({ criteria: criteria });
  };
  onModuleExit = () => {
    this.props.onModuleExit();
  };
  generatePDF = () => {
    this.generateReport(1);
  };
  generateExcel = () => {
    this.generateReport(2);
  };
  generateReport = (reportType) => {
    this.setState({
      isShowProgressBarPopup: true,
      progressLoadingText: "Generating Report ...",
    });
    let criteria = this.state.criteria;
    criteria.companyCode = this.companyCode;
    let reportBean = new RestReportBean();
    reportBean.reportType = reportType;
    let listRequest = new FabricStyleWeeklyMonthlyATSResultRequest();
    listRequest.criteria = criteria;
    listRequest.reportBean = reportBean;
    if (reportBean.reportType == 1) {
      if (
        SecurityAccessManager.FabricWeeklyMonthlyATSPdfReport_IsAccessible()
      ) {
        ReportService.generateFabricStyleWeeklyMonthlyATSResultReport(
          listRequest,
          this.generateFabricWeeklyPageResponse,
          this.errorCallBack
        );
      } else {
        this.inValidAccess(2);
      }
    } else if (reportBean.reportType == 2) {
      if (
        SecurityAccessManager.FabricWeeklyMonthlyATSExcelReport_IsAccessible()
      ) {
        ReportService.generateFabricStyleWeeklyMonthlyATSResultReport(
          listRequest,
          this.generateFabricWeeklyPageResponse,
          this.errorCallBack
        );
      } else {
        this.inValidAccess(3);
      }
    }
  };
  generateFabricWeeklyPageResponse = (response) => {
    this.showErrorMessage(response.data);
    if (response.data != null && response.data.reportResult != null) {
      if (!isEmptyString(response.data.reportResult.reportFileID)) {
        let reportFilePath = response.data.reportResult.reportFileID;
        window.open(this.report_url + reportFilePath);
      }
    }
    this.setState({
      isShowProgressBarPopup: false,
      progressLoadingText: "",
    });
  };
  onPopupModalExit = () => {
    this.closeModalCallBack(false);
  };
  closeModalCallBack = (isOpen) => {
    this.setState({
      isShowFabricStyleModule: isOpen,
      isShowVendorModule: isOpen,
      isShowSalesModule: isOpen,
      isShowCustomerModule: isOpen,
      isShowPurchaseOrderModule: isOpen,
      moduleForPopup: [],
    });
  };
  vendorQtyClick = (e, val, rowData) => {
    if (e.detail === 1) {
      if (val != 0) {
        this.setState({
          isShowProgressBarPopup: true,
          progressLoadingText: "Loading Popup ...",
        });
        this.setState({ vendorData: rowData });
        let criteria = this.state.criteria;
        let vendorCriteria = new VendorPurchaseOnOrderSearchCriteria();
        vendorCriteria.companyCode = this.companyCode;
        vendorCriteria.fabricStyleCode = criteria.fabricStyleCode;
        vendorCriteria.colorCode = criteria.fabricStyleColorCode;
        vendorCriteria.isFetchDetailsTillOrderStopDate = true;
        VendorService.getVendorPurchaseOnOrderDetails(
          vendorCriteria,
          this.vendorOnOrderPageResponse,
          this.errorCallBack
        );
      } else {
        let errMsg = "No Data's Found";
        let errList = [];
        errList.push(errMsg);
        this.setState({
          alertMessage: errList,
          alertType: "danger",
          isShowAlert: true,
          isShowProgressBarPopup: false,
          progressLoadingText: "",
        });
      }
    }
  };
  vendorOnOrderPageResponse = (response) => {
    this.showErrorMessage(response.data);
    if (response.data != null && response.data.orderDetailsResult != null) {
      if (response.data.orderDetailsResult.onOrderInfoDetails != null) {
        let vendorQtyList = response.data.orderDetailsResult.onOrderInfoDetails;
        this.setState({
          vendorQtyList: vendorQtyList,
          isShowVendorQtyPopup: true,
        });
      }
    }
    this.setState({
      isShowProgressBarPopup: false,
      progressLoadingText: "",
    });
  };

  customerQtyClick = (e, val, rowData) => {
    if (e.detail === 1) {
      if (val != 0) {
        this.setState({
          isShowProgressBarPopup: true,
          progressLoadingText: "Loading Popup ...",
        });
        this.setState({ customerData: rowData });
        let criteria = this.state.criteria;
        let customerCriteria = new CustomerSalesOnOrderSearchCriteria();
        customerCriteria.companyCode = this.companyCode;
        customerCriteria.fabricStyleCode = criteria.fabricStyleCode;
        customerCriteria.colorCode = criteria.fabricStyleColorCode;
        CustomerService.getCustomerSalesOnOrderDetails(
          customerCriteria,
          this.customerOnOrderPageResponse,
          this.errorCallBack
        );
      } else {
        let errMsg = "No Data's Found";
        let errList = [];
        errList.push(errMsg);
        this.setState({
          alertMessage: errList,
          alertType: "danger",
          isShowAlert: true,
          isShowProgressBarPopup: false,
          progressLoadingText: "",
        });
      }
    }
  };
  customerOnOrderPageResponse = (response) => {
    this.showErrorMessage(response.data);
    if (response.data != null && response.data.orderDetailsResult != null) {
      if (response.data.orderDetailsResult.onOrderInfoDetails != null) {
        let customerQtyList =
          response.data.orderDetailsResult.onOrderInfoDetails;

        this.setState({
          customerQtyList: customerQtyList,
          isShowCustomerQtyPopup: true,
        });
      }
    }
    this.setState({
      isShowProgressBarPopup: false,
      progressLoadingText: "",
    });
  };
  viewFabricModule = (e, code) => {
    if (e.detail === 1) {
      if (code !== "" && code !== undefined) {
        this.setState({
          isShowFabricStyleModule: true,
          moduleForPopup: (
            <PopupFabricStyleModule
              fabricStyleCode={code}
              onModuleExit={this.onPopupModalExit}
            />
          ),
        });
      }
    }
  };
  viewPurchaseModule = (e, code) => {
    if (e.detail === 1) {
      if (code !== "" && code !== undefined) {
        this.setState({
          isShowPurchaseOrderModule: true,
          moduleForPopup: (
            <PopupPurchaseOrderModule
              code={code}
              onModuleExit={this.onPopupModalExit}
            />
          ),
        });
      }
    }
  };
  viewVendorModule = (e, code) => {
    if (e.detail === 1) {
      if (code !== "" && code !== undefined) {
        this.setState({
          isShowVendorModule: true,
          moduleForPopup: (
            <PopupVendorModule
              vendorCode={code}
              onModuleExit={this.onPopupModalExit}
            />
          ),
        });
      }
    }
  };
  viewSalesModule = (e, code) => {
    if (e.detail === 1) {
      if (code !== "" && code !== undefined) {
        this.setState({
          isShowSalesModule: true,
          moduleForPopup: (
            <PopupSalesModule
              code={code}
              onModuleExit={this.onPopupModalExit}
            />
          ),
        });
      }
    }
  };
  viewCustomerModule = (e, code) => {
    if (e.detail === 1) {
      if (code !== "" && code !== undefined) {
        this.setState({
          isShowCustomerModule: true,
          moduleForPopup: (
            <PopupCustomerModule
              customerCode={code}
              onModuleExit={this.onPopupModalExit}
            />
          ),
        });
      }
    }
  };
  closeAlertModalCallBack = (isShowPopup) => {
    this.setState({
      isShowVendorQtyPopup: isShowPopup,
      isShowCustomerQtyPopup: isShowPopup,
    });
  };
  handleSortingOnVendorChange = (e, accessor) => {
    if (e.detail === 1) {
      let sortField = accessor;
      let order = this.state.order;
      let sortOrder =
        accessor === sortField && order === "asc" ? "desc" : "asc";
      this.setState({
        order: sortOrder,
        sortField: sortField,
      });
      this.handleVendorQtySorting(sortField, sortOrder);
    }
  };
  handleVendorQtySorting = (sortField, sortOrder) => {
    let vendorQtyList = this.state.vendorQtyList;
    if (sortField && !isEmptyArray(vendorQtyList)) {
      const sorted = [...vendorQtyList].sort((a, b) => {
        if (a[sortField] === null) return 1;
        if (b[sortField] === null) return -1;
        if (a[sortField] === null && b[sortField] === null) return 0;
        return (
          a[sortField].toString().localeCompare(b[sortField].toString(), "en", {
            numeric: true,
          }) * (sortOrder === "asc" ? 1 : -1)
        );
      });
      this.setState({ vendorQtyList: sorted });
    }
  };
  handleSortingOnCustomerChange = (e, accessor) => {
    if (e.detail === 1) {
      let sortField = accessor;
      let order = this.state.order;
      let sortOrder =
        accessor === sortField && order === "asc" ? "desc" : "asc";
      this.setState({
        order: sortOrder,
        sortField: sortField,
      });
      this.handleCustomerQtySorting(sortField, sortOrder);
    }
  };
  handleCustomerQtySorting = (sortField, sortOrder) => {
    let customerQtyList = this.state.customerQtyList;
    if (sortField && !isEmptyArray(customerQtyList)) {
      const sorted = [...customerQtyList].sort((a, b) => {
        if (a[sortField] === null) return 1;
        if (b[sortField] === null) return -1;
        if (a[sortField] === null && b[sortField] === null) return 0;
        return (
          a[sortField].toString().localeCompare(b[sortField].toString(), "en", {
            numeric: true,
          }) * (sortOrder === "asc" ? 1 : -1)
        );
      });
      this.setState({ customerQtyList: sorted });
    }
  };
  render() {
    let inquiryDataList = this.state.inquiryDataList;
    let vendorData = this.state.vendorData;
    let customerData = this.state.customerData;
    return (
      <div>
        <ProgressBar
          progressLoadingText={this.state.progressLoadingText}
          isShowPopup={this.state.isShowProgressBarPopup}
        />
        <AlertToolBox
          alertMsgList={this.state.alertMessage}
          alertErrorType={this.state.alertType}
          isShowAlert={this.state.isShowAlert}
          hideAlertCallBack={this.hideAlertCallBack}
        />
        <BaseInquiryToolBar
          pageTitle={this.state.pageTitle}
          isShowExecuteButton={this.state.isShowExecuteButton}
          isShowClearCriteriaButton={this.state.isShowClearCriteriaButton}
          isShowClearErrorButton={this.state.isShowClearErrorButton}
          isShowResetButton={this.state.isShowResetButton}
          isShowPDFButton={this.state.isShowPDFButton}
          isShowExcelButton={this.state.isShowExcelButton}
          isShowExitButton={this.state.isShowExitButton}
          onModuleExit={this.onModuleExit}
          execute={this.execute}
          clearCriteria={this.clearCriteria}
          clearError={this.clearError}
          reset={this.resetInquiry}
          generatePDF={this.generatePDF}
          generateExcel={this.generateExcel}
        />
        <CriteriaView
          {...this.state}
          onChange={this.onChange}
          fabricCodeOnChange={this.fabricCodeOnChange}
          fabricEnterKeyEventHandler={this.fabricEnterKeyEventHandler}
          displayAutoCompleteFabricList={this.displayAutoCompleteFabricList}
          fabricColourEnterKeyEventHandler={
            this.fabricColourEnterKeyEventHandler
          }
          displayAutoCompleteFabricColorList={
            this.displayAutoCompleteFabricColorList
          }
          onFabricColourCodeChange={this.onFabricColourCodeChange}
        />
        {this.state.isInquiryDatasFound && (
          <div className="div_default">
            <Table id="fabrics_tables">
              <thead>
                <tr>
                  <th></th>
                  {inquiryDataList.map((list, i) => (
                    <th className="date_width">{list.agingDate}</th>
                  ))}
                </tr>
              </thead>
              <tbody>
                <tr>
                  <th>Open Balance </th>
                  {inquiryDataList.map((list) => (
                    <td className="text-right">  {toCommaSeperatedAmount(list.openBalanceQuantity)} </td>
                  ))}
                </tr>
                <tr>
                  <th>OnHand </th>
                  {inquiryDataList.map((list) => (
                    <td className="text-right">  {toCommaSeperatedAmount(list.onHandQuantity)}</td>
                  ))}
                </tr>
                <tr>
                  <th>VendorOnOrder </th>
                  {inquiryDataList.map((list) => (
                    <td className="text-right">
                      <Button
                        size="sm"
                        variant="secondry"
                        className="hyperLinkText"
                        onClick={(e) =>
                          this.vendorQtyClick(
                            e,
                            list.vendorOnOrderQuantity,
                            list
                          )
                        }
                      >
                        {toCommaSeperatedAmount(list.vendorOnOrderQuantity)}
                        
                      </Button>
                    </td>
                  ))}
                </tr>
                <tr>
                  <th>CustomerOnOrder </th>
                  {inquiryDataList.map((list) => (
                    <td className="text-right">
                      <Button
                        variant="secondry"
                        size="sm"
                        className="hyperLinkText"
                        onClick={(e) =>
                          this.customerQtyClick(
                            e,
                            list.customerOnOrderQuantity,
                            list
                          )
                        }
                      >
                         {toCommaSeperatedAmount(list.customerOnOrderQuantity)}
                        
                      </Button>
                    </td>
                  ))}
                </tr>
                <tr>
                  <th>EndBalance </th>
                  {inquiryDataList.map((list) => (
                    <td className="text-right"> {toCommaSeperatedAmount(list.endBalanceQuantity)}</td>
                  ))}
                </tr>
              </tbody>
            </Table>
            {inquiryDataList.length != 0 ? null : (
              <div className="no_Data">{"No Data"}</div>
            )}
          </div>
        )}
        <MultiViewPopup
          isModulePopup={false}
          isShowPopup={this.state.isShowVendorQtyPopup}
          closeOnEsc={false}
          closeAlertModalCallBack={this.closeAlertModalCallBack}
          popupLvlClass={"popupSizeLevel0"}
          title={"Vendor OnOrder Details"}
          closeOnDocumentClick={false}
          lineFunctionalityForm={this.lineFunctionalityForm}
          content={
            <div className="">
              {this.state.vendorData && (
                <div>
                  <Row>
                    <Col sm="1">
                      <FormLabel>CompanyCode</FormLabel>
                    </Col>
                    <Col sm="2">
                      <InputTextbox value={this.companyCode} disabled={true} />
                    </Col>
                    <Col sm="1">
                      <FormLabel>AgingDate</FormLabel>
                    </Col>
                    <Col sm="2">
                      <InputTextbox
                        value={vendorData.agingDate}
                        disabled={true}
                      />
                    </Col>
                    <Col sm="1">
                      <FormLabel>OpenBalance Qty</FormLabel>
                    </Col>
                    <Col sm="2">
                      <NumberFormatInputbox
                        value={vendorData.openBalanceQuantity}
                        disabled={true}
                        className="text-right"
                      />
                    </Col>
                    <Col sm="1">
                      <FormLabel>EndBalance Qty</FormLabel>
                    </Col>
                    <Col sm="2">
                      <NumberFormatInputbox
                        value={vendorData.endBalanceQuantity}
                        disabled={true}
                        className="text-right"
                      />
                    </Col>
                  </Row>
                  <Row>
                    <Col sm="1">
                      <FormLabel>OnHandQuantity</FormLabel>
                    </Col>
                    <Col sm="2">
                      <InputTextbox
                        value={vendorData.onHandQuantity}
                        disabled={true}
                        className="text-right"
                      />
                    </Col>
                    <Col sm="1">
                      <FormLabel>StartDate</FormLabel>
                    </Col>
                    <Col sm="2">
                      <InputTextbox
                        value={vendorData.startDate}
                        disabled={true}
                      />
                    </Col>
                    <Col sm="1">
                      <FormLabel>EndDate</FormLabel>
                    </Col>
                    <Col sm="2">
                      <InputTextbox
                        value={vendorData.endDate}
                        disabled={true}
                      />
                    </Col>
                    <Col sm="1">
                      <FormLabel>OnOrder Qty</FormLabel>
                    </Col>
                    <Col sm="2">
                      <NumberFormatInputbox
                        value={vendorData.vendorOnOrderQuantity}
                        disabled={true}
                        className="text-right"
                      />
                    </Col>
                  </Row>
                </div>
              )}
              <div className="div_default">
                <Table id="fabrics_tables">
                  <thead>
                    <th
                      onClick={(e) =>
                        this.handleSortingOnVendorChange(e, "vendorCode")
                      }
                    >
                      Vendor
                      {this.state.order === "desc" &&
                      this.state.sortField === "vendorCode" ? (
                        <span className="drp-dwn-cntr">
                          <DropDwnUp />
                        </span>
                      ) : (
                        <span className="drp-dwn-cntr">
                          <DropDwnDown />
                        </span>
                      )}
                    </th>
                    <th
                      onClick={(e) =>
                        this.handleSortingOnVendorChange(e, "vendorName")
                      }
                    >
                      VendorName
                      {this.state.order === "desc" &&
                      this.state.sortField === "vendorName" ? (
                        <span className="drp-dwn-cntr">
                          <DropDwnUp />
                        </span>
                      ) : (
                        <span className="drp-dwn-cntr">
                          <DropDwnDown />
                        </span>
                      )}
                    </th>
                    <th
                      onClick={(e) =>
                        this.handleSortingOnVendorChange(e, "fabricStyleCode")
                      }
                    >
                      {this.state.is3PL ? "Item " : "FabricStyle#"}
                      {this.state.order === "desc" &&
                      this.state.sortField === "fabricStyleCode" ? (
                        <span className="drp-dwn-cntr">
                          <DropDwnUp />
                        </span>
                      ) : (
                        <span className="drp-dwn-cntr">
                          <DropDwnDown />
                        </span>
                      )}
                    </th>
                    <th
                      onClick={(e) =>
                        this.handleSortingOnVendorChange(
                          e,
                          "fabricStyleShortName"
                        )
                      }
                    >
                      {this.state.is3PL ? "Item Name" : "FabricStyleName"}
                      {this.state.order === "desc" &&
                      this.state.sortField === "fabricStyleShortName" ? (
                        <span className="drp-dwn-cntr">
                          <DropDwnUp />
                        </span>
                      ) : (
                        <span className="drp-dwn-cntr">
                          <DropDwnDown />
                        </span>
                      )}
                    </th>
                    <th
                      onClick={(e) =>
                        this.handleSortingOnVendorChange(e, "colorCode")
                      }
                    >
                      Color
                      {this.state.order === "desc" &&
                      this.state.sortField === "colorCode" ? (
                        <span className="drp-dwn-cntr">
                          <DropDwnUp />
                        </span>
                      ) : (
                        <span className="drp-dwn-cntr">
                          <DropDwnDown />
                        </span>
                      )}
                    </th>
                    <th
                      onClick={(e) =>
                        this.handleSortingOnVendorChange(e, "widthCode")
                      }
                    >
                      Width
                      {this.state.order === "desc" &&
                      this.state.sortField === "widthCode" ? (
                        <span className="drp-dwn-cntr">
                          <DropDwnUp />
                        </span>
                      ) : (
                        <span className="drp-dwn-cntr">
                          <DropDwnDown />
                        </span>
                      )}
                    </th>
                    <th
                      onClick={(e) =>
                        this.handleSortingOnVendorChange(e, "skuNumber")
                      }
                    >
                      SKU
                      {this.state.order === "desc" &&
                      this.state.sortField === "skuNumber" ? (
                        <span className="drp-dwn-cntr">
                          <DropDwnUp />
                        </span>
                      ) : (
                        <span className="drp-dwn-cntr">
                          <DropDwnDown />
                        </span>
                      )}
                    </th>
                    <th
                      onClick={(e) =>
                        this.handleSortingOnVendorChange(e, "orderUom")
                      }
                    >
                      UOM
                      {this.state.order === "desc" &&
                      this.state.sortField === "orderUom" ? (
                        <span className="drp-dwn-cntr">
                          <DropDwnUp />
                        </span>
                      ) : (
                        <span className="drp-dwn-cntr">
                          <DropDwnDown />
                        </span>
                      )}
                    </th>
                    <th
                      onClick={(e) =>
                        this.handleSortingOnVendorChange(e, "onOrderQuantity")
                      }
                    >
                      OnOrderQty
                      {this.state.order === "desc" &&
                      this.state.sortField === "onOrderQuantity" ? (
                        <span className="drp-dwn-cntr">
                          <DropDwnUp />
                        </span>
                      ) : (
                        <span className="drp-dwn-cntr">
                          <DropDwnDown />
                        </span>
                      )}
                    </th>
                    <th
                      onClick={(e) =>
                        this.handleSortingOnVendorChange(
                          e,
                          "purchaseOrderNumber"
                        )
                      }
                    >
                      P.O#
                      {this.state.order === "desc" &&
                      this.state.sortField === "purchaseOrderNumber" ? (
                        <span className="drp-dwn-cntr">
                          <DropDwnUp />
                        </span>
                      ) : (
                        <span className="drp-dwn-cntr">
                          <DropDwnDown />
                        </span>
                      )}
                    </th>
                    <th
                      onClick={(e) =>
                        this.handleSortingOnVendorChange(
                          e,
                          "purchaseOrderStartDate"
                        )
                      }
                    >
                      P.O.StartDate
                      {this.state.order === "desc" &&
                      this.state.sortField === "purchaseOrderStartDate" ? (
                        <span className="drp-dwn-cntr">
                          <DropDwnUp />
                        </span>
                      ) : (
                        <span className="drp-dwn-cntr">
                          <DropDwnDown />
                        </span>
                      )}
                    </th>
                    <th
                      onClick={(e) =>
                        this.handleSortingOnVendorChange(
                          e,
                          "purchaseOrderStopDate"
                        )
                      }
                    >
                      P.O.StopDate
                      {this.state.order === "desc" &&
                      this.state.sortField === "purchaseOrderStopDate" ? (
                        <span className="drp-dwn-cntr">
                          <DropDwnUp />
                        </span>
                      ) : (
                        <span className="drp-dwn-cntr">
                          <DropDwnDown />
                        </span>
                      )}
                    </th>
                    <th
                      onClick={(e) =>
                        this.handleSortingOnVendorChange(e, "xFactoryDate")
                      }
                    >
                      xFactoryDate
                      {this.state.order === "desc" &&
                      this.state.sortField === "xFactoryDate" ? (
                        <span className="drp-dwn-cntr">
                          <DropDwnUp />
                        </span>
                      ) : (
                        <span className="drp-dwn-cntr">
                          <DropDwnDown />
                        </span>
                      )}
                    </th>
                    <th
                      onClick={(e) =>
                        this.handleSortingOnVendorChange(e, "inDCDate")
                      }
                    >
                      InDCDate
                      {this.state.order === "desc" &&
                      this.state.sortField === "inDCDate" ? (
                        <span className="drp-dwn-cntr">
                          <DropDwnUp />
                        </span>
                      ) : (
                        <span className="drp-dwn-cntr">
                          <DropDwnDown />
                        </span>
                      )}
                    </th>
                    <th
                      onClick={(e) =>
                        this.handleSortingOnVendorChange(e, "etaDate")
                      }
                    >
                      EtaDate
                      {this.state.order === "desc" &&
                      this.state.sortField === "etaDate" ? (
                        <span className="drp-dwn-cntr">
                          <DropDwnUp />
                        </span>
                      ) : (
                        <span className="drp-dwn-cntr">
                          <DropDwnDown />
                        </span>
                      )}
                    </th>
                    <th
                      onClick={(e) =>
                        this.handleSortingOnVendorChange(
                          e,
                          "inConsolidatorDCDate"
                        )
                      }
                    >
                      inConsolidateDate
                      {this.state.order === "desc" &&
                      this.state.sortField === "inConsolidatorDCDate" ? (
                        <span className="drp-dwn-cntr">
                          <DropDwnUp />
                        </span>
                      ) : (
                        <span className="drp-dwn-cntr">
                          <DropDwnDown />
                        </span>
                      )}
                    </th>
                  </thead>
                  <tbody>
                    {this.state.vendorQtyList.map((list, index) => (
                      <tr key={index}>
                        <td>
                          <Button
                            size="sm"
                            variant="secondry"
                            className="hyperLinkText"
                            onClick={(e) =>
                              this.viewVendorModule(e, list.vendorCode)
                            }
                          >
                            {list.vendorCode}
                          </Button>
                        </td>
                        <td>{list.vendorName}</td>
                        <td>
                          <Button
                            size="sm"
                            variant="secondry"
                            className="hyperLinkText"
                            onClick={(e) =>
                              this.viewFabricModule(e, list.fabricStyleCode)
                            }
                          >
                            {list.fabricStyleCode}
                          </Button>
                        </td>
                        <td>{list.fabricStyleShortName}</td>
                        <td>{list.colorCode}</td>
                        <td className="text-right">{list.widthCode}</td>
                        <td className="text-right">{list.skuNumber}</td>
                        <td>{list.orderUom}</td>
                        <td className="text-right"> {toCommaSeperatedAmount(list.onOrderQuantity)} </td>
                        <td>
                          <Button
                            size="sm"
                            variant="secondry"
                            className="hyperLinkText"
                            onClick={(e) =>
                              this.viewPurchaseModule(
                                e,
                                list.purchaseOrderNumber
                              )
                            }
                          >
                            {list.purchaseOrderNumber}
                          </Button>
                        </td>
                        <td>{list.purchaseOrderStartDate}</td>
                        <td>{list.purchaseOrderStopDate}</td>
                        <td>{list.xFactoryDate}</td>
                        <td>{list.inDCDate}</td>
                        <td>{list.etaDate}</td>
                        <td>{list.inConsolidatorDCDate}</td>
                      </tr>
                    ))}
                  </tbody>
                </Table>
              </div>
            </div>
          }
        />
        <MultiViewPopup
          isModulePopup={false}
          isShowPopup={this.state.isShowCustomerQtyPopup}
          closeOnEsc={false}
          closeAlertModalCallBack={this.closeAlertModalCallBack}
          popupLvlClass={"popupSizeLevel0"}
          title={"Customer OnOrder Details"}
          closeOnDocumentClick={false}
          lineFunctionalityForm={this.lineFunctionalityForm}
          content={
            <div className="">
              {this.state.customerData && (
                <div>
                  <Row>
                    <Col sm="1">
                      <FormLabel>CompanyCode</FormLabel>
                    </Col>
                    <Col sm="2">
                      <InputTextbox value={this.companyCode} disabled={true} />
                    </Col>

                    <Col sm="1">
                      <FormLabel>AgingDate</FormLabel>
                    </Col>
                    <Col sm="2">
                      <InputTextbox
                        value={customerData.agingDate}
                        disabled={true}
                      />
                    </Col>
                    <Col sm="1">
                      <FormLabel>OpenBalance Qty</FormLabel>
                    </Col>
                    <Col sm="2">
                      <NumberFormatInputbox
                        value={customerData.openBalanceQuantity}
                        disabled={true}
                        className="text-right"
                      />
                    </Col>
                    <Col sm="1">
                      <FormLabel>EndBalance Qty</FormLabel>
                    </Col>
                    <Col sm="2">
                      <NumberFormatInputbox
                        value={customerData.endBalanceQuantity}
                        disabled={true}
                        className="text-right"
                      />
                    </Col>
                  </Row>
                  <Row>
                    <Col sm="1">
                      <FormLabel>OnHandQuantity</FormLabel>
                    </Col>
                    <Col sm="2">
                      <InputTextbox
                        value={customerData.onHandQuantity}
                        disabled={true}
                        className="text-right"
                      />
                    </Col>
                    <Col sm="1">
                      <FormLabel>StartDate</FormLabel>
                    </Col>
                    <Col sm="2">
                      <InputTextbox
                        value={customerData.startDate}
                        disabled={true}
                      />
                    </Col>
                    <Col sm="1">
                      <FormLabel>EndDate</FormLabel>
                    </Col>
                    <Col sm="2">
                      <InputTextbox
                        value={customerData.endDate}
                        disabled={true}
                      />
                    </Col>
                    <Col sm="1">
                      <FormLabel>OnOrder Qty</FormLabel>
                    </Col>
                    <Col sm="2">
                      <NumberFormatInputbox
                        value={customerData.customerOnOrderQuantity}
                        disabled={true}
                        className="text-right"
                      />
                    </Col>
                  </Row>
                </div>
              )}
              <div className="div_default">
                <Table id="fabrics_tables">
                  <thead>
                    <th
                      onClick={(e) =>
                        this.handleSortingOnCustomerChange(e, "customerCode")
                      }
                    >
                      Customer
                      {this.state.order === "desc" &&
                      this.state.sortField === "customerCode" ? (
                        <span className="drp-dwn-cntr">
                          <DropDwnUp />
                        </span>
                      ) : (
                        <span className="drp-dwn-cntr">
                          <DropDwnDown />
                        </span>
                      )}
                    </th>
                    <th
                      onClick={(e) =>
                        this.handleSortingOnCustomerChange(e, "customerName")
                      }
                    >
                      CustomerName
                      {this.state.order === "desc" &&
                      this.state.sortField === "customerName" ? (
                        <span className="drp-dwn-cntr">
                          <DropDwnUp />
                        </span>
                      ) : (
                        <span className="drp-dwn-cntr">
                          <DropDwnDown />
                        </span>
                      )}
                    </th>
                    <th
                      onClick={(e) =>
                        this.handleSortingOnCustomerChange(e, "fabricStyleCode")
                      }
                    >
                      {this.state.is3PL ? "Item " : "FabricStyleCode#"}
                      {this.state.order === "desc" &&
                      this.state.sortField === "fabricStyleCode" ? (
                        <span className="drp-dwn-cntr">
                          <DropDwnUp />
                        </span>
                      ) : (
                        <span className="drp-dwn-cntr">
                          <DropDwnDown />
                        </span>
                      )}
                    </th>
                    <th
                      onClick={(e) =>
                        this.handleSortingOnCustomerChange(
                          e,
                          "fabricStyleShortName"
                        )
                      }
                    >
                      {this.state.is3PL ? "Item Name" : "FabricStyle Name"}
                      {this.state.order === "desc" &&
                      this.state.sortField === "fabricStyleShortName" ? (
                        <span className="drp-dwn-cntr">
                          <DropDwnUp />
                        </span>
                      ) : (
                        <span className="drp-dwn-cntr">
                          <DropDwnDown />
                        </span>
                      )}
                    </th>
                    <th
                      onClick={(e) =>
                        this.handleSortingOnCustomerChange(e, "colorCode")
                      }
                    >
                      Color
                      {this.state.order === "desc" &&
                      this.state.sortField === "colorCode" ? (
                        <span className="drp-dwn-cntr">
                          <DropDwnUp />
                        </span>
                      ) : (
                        <span className="drp-dwn-cntr">
                          <DropDwnDown />
                        </span>
                      )}
                    </th>
                    <th
                      onClick={(e) =>
                        this.handleSortingOnCustomerChange(e, "widthCode")
                      }
                    >
                      Width
                      {this.state.order === "desc" &&
                      this.state.sortField === "widthCode" ? (
                        <span className="drp-dwn-cntr">
                          <DropDwnUp />
                        </span>
                      ) : (
                        <span className="drp-dwn-cntr">
                          <DropDwnDown />
                        </span>
                      )}
                    </th>
                    <th
                      onClick={(e) =>
                        this.handleSortingOnCustomerChange(e, "orderUom")
                      }
                    >
                      UOM
                      {this.state.order === "desc" &&
                      this.state.sortField === "orderUom" ? (
                        <span className="drp-dwn-cntr">
                          <DropDwnUp />
                        </span>
                      ) : (
                        <span className="drp-dwn-cntr">
                          <DropDwnDown />
                        </span>
                      )}
                    </th>
                    <th
                      onClick={(e) =>
                        this.handleSortingOnCustomerChange(e, "skuNumber")
                      }
                    >
                      SKU
                      {this.state.order === "desc" &&
                      this.state.sortField === "skuNumber" ? (
                        <span className="drp-dwn-cntr">
                          <DropDwnUp />
                        </span>
                      ) : (
                        <span className="drp-dwn-cntr">
                          <DropDwnDown />
                        </span>
                      )}
                    </th>
                    <th
                      onClick={(e) =>
                        this.handleSortingOnCustomerChange(e, "onOrderQuantity")
                      }
                    >
                      OnOrderQty
                      {this.state.order === "desc" &&
                      this.state.sortField === "onOrderQuantity" ? (
                        <span className="drp-dwn-cntr">
                          <DropDwnUp />
                        </span>
                      ) : (
                        <span className="drp-dwn-cntr">
                          <DropDwnDown />
                        </span>
                      )}
                    </th>
                    <th
                      onClick={(e) =>
                        this.handleSortingOnCustomerChange(
                          e,
                          "customerPONumber"
                        )
                      }
                    >
                      CustP.O#
                      {this.state.order === "desc" &&
                      this.state.sortField === "customerPONumber" ? (
                        <span className="drp-dwn-cntr">
                          <DropDwnUp />
                        </span>
                      ) : (
                        <span className="drp-dwn-cntr">
                          <DropDwnDown />
                        </span>
                      )}
                    </th>
                    <th
                      onClick={(e) =>
                        this.handleSortingOnCustomerChange(
                          e,
                          "salesOrderNumber"
                        )
                      }
                    >
                      S.O#
                      {this.state.order === "desc" &&
                      this.state.sortField === "salesOrderNumber" ? (
                        <span className="drp-dwn-cntr">
                          <DropDwnUp />
                        </span>
                      ) : (
                        <span className="drp-dwn-cntr">
                          <DropDwnDown />
                        </span>
                      )}
                    </th>
                    <th
                      onClick={(e) =>
                        this.handleSortingOnCustomerChange(e, "salesOrderDate")
                      }
                    >
                      S.ODate
                      {this.state.order === "desc" &&
                      this.state.sortField === "salesOrderDate" ? (
                        <span className="drp-dwn-cntr">
                          <DropDwnUp />
                        </span>
                      ) : (
                        <span className="drp-dwn-cntr">
                          <DropDwnDown />
                        </span>
                      )}
                    </th>
                    <th
                      onClick={(e) =>
                        this.handleSortingOnCustomerChange(
                          e,
                          "salesOrderStartDate"
                        )
                      }
                    >
                      S.O.StartDate
                      {this.state.order === "desc" &&
                      this.state.sortField === "salesOrderStartDate" ? (
                        <span className="drp-dwn-cntr">
                          <DropDwnUp />
                        </span>
                      ) : (
                        <span className="drp-dwn-cntr">
                          <DropDwnDown />
                        </span>
                      )}
                    </th>
                    <th
                      onClick={(e) =>
                        this.handleSortingOnCustomerChange(
                          e,
                          "salesOrderStopDate"
                        )
                      }
                    >
                      Latest ShipDate
                      {this.state.order === "desc" &&
                      this.state.sortField === "salesOrderStopDate" ? (
                        <span className="drp-dwn-cntr">
                          <DropDwnUp />
                        </span>
                      ) : (
                        <span className="drp-dwn-cntr">
                          <DropDwnDown />
                        </span>
                      )}
                    </th>
                    <th
                      onClick={(e) =>
                        this.handleSortingOnCustomerChange(e, "salesPersonCode")
                      }
                    >
                      SalesPerson
                      {this.state.order === "desc" &&
                      this.state.sortField === "salesPersonCode" ? (
                        <span className="drp-dwn-cntr">
                          <DropDwnUp />
                        </span>
                      ) : (
                        <span className="drp-dwn-cntr">
                          <DropDwnDown />
                        </span>
                      )}
                    </th>
                    <th
                      onClick={(e) =>
                        this.handleSortingOnCustomerChange(
                          e,
                          "customerSalesRepresentativeCode"
                        )
                      }
                    >
                      CSR
                      {this.state.order === "desc" &&
                      this.state.sortField ===
                        "customerSalesRepresentativeCode" ? (
                        <span className="drp-dwn-cntr">
                          <DropDwnUp />
                        </span>
                      ) : (
                        <span className="drp-dwn-cntr">
                          <DropDwnDown />
                        </span>
                      )}
                    </th>
                  </thead>
                  <tbody>
                    {this.state.customerQtyList.map((list, index) => (
                      <tr key={index}>
                        <td>
                          <Button
                            size="sm"
                            variant="secondry"
                            className="hyperLinkText"
                            onClick={(e) =>
                              this.viewCustomerModule(e, list.customerCode)
                            }
                          >
                            {list.customerCode}
                          </Button>
                        </td>
                        <td>{list.customerName}</td>
                        <td>
                          <Button
                            size="sm"
                            variant="secondry"
                            className="hyperLinkText"
                            onClick={(e) =>
                              this.viewFabricModule(e, list.fabricStyleCode)
                            }
                          >
                            {list.fabricStyleCode}
                          </Button>
                        </td>
                        <td>{list.fabricStyleShortName}</td>
                        <td>{list.colorCode}</td>
                        <td className="text-right">{list.widthCode}</td>
                        <td>{list.orderUom}</td>
                        <td className="text-right">{list.skuNumber}</td>
                        <td className="text-right">{toCommaSeperatedAmount(list.onOrderQuantity)}</td>
                        <td>{list.customerPONumber}</td>
                        <td>
                          <Button
                            size="sm"
                            variant="secondry"
                            className="hyperLinkText"
                            onClick={(e) =>
                              this.viewSalesModule(e, list.salesOrderNumber)
                            }
                          >
                            {list.salesOrderNumber}
                          </Button>
                        </td>
                        <td>{list.salesOrderDate}</td>
                        <td>{list.salesOrderStartDate}</td>
                        <td>{list.salesOrderStopDate}</td>
                        <td>{list.salesPersonCode}</td>
                        <td>{list.customerSalesRepresentativeCode}</td>
                      </tr>
                    ))}
                  </tbody>
                </Table>
              </div>
            </div>
          }
        />
        <MultiViewPopup
          isModulePopup={true}
          id="modulePopup"
          popupLvlClass={"popupSizeLevel1"}
          isShowPopup={this.state.isShowFabricStyleModule}
          closeModalCallBack={this.closeModalCallBack}
          module={this.state.moduleForPopup}
        />
        <MultiViewPopup
          isModulePopup={true}
          id="modulePopup"
          popupLvlClass={"popupSizeLevel1"}
          isShowPopup={this.state.isShowSalesModule}
          closeModalCallBack={this.closeModalCallBack}
          module={this.state.moduleForPopup}
        />
        <MultiViewPopup
          isModulePopup={true}
          id="modulePopup"
          popupLvlClass={"popupSizeLevel1"}
          isShowPopup={this.state.isShowCustomerModule}
          closeModalCallBack={this.closeModalCallBack}
          module={this.state.moduleForPopup}
        />
        <MultiViewPopup
          isModulePopup={true}
          id="modulePopup"
          popupLvlClass={"popupSizeLevel1"}
          isShowPopup={this.state.isShowVendorModule}
          closeModalCallBack={this.closeModalCallBack}
          module={this.state.moduleForPopup}
        />
        <MultiViewPopup
          isModulePopup={true}
          id="modulePopup"
          popupLvlClass={"popupSizeLevel1"}
          isShowPopup={this.state.isShowPurchaseOrderModule}
          closeModalCallBack={this.closeModalCallBack}
          module={this.state.moduleForPopup}
        />
      </div>
    );
  }
}
export function CriteriaView(props) {
  const [show, setShow] = useState(false);
  const onChange = (e) => props.onChange(e);
  let criteria = props.criteria;
  let fabricLookupHandler = props.fabricLookupHandler;
  const fabricCodeOnChange = (e) => props.fabricCodeOnChange(e);
  const fabricCodeRef = props.fabricCodeRef;
  const colorCodeRef = props.colorCodeRef;
  const onFabricColourCodeChange = (e) => {
    props.onFabricColourCodeChange(e);
  };
  const fabricEnterKeyEventHandler = (e) => {
    props.fabricEnterKeyEventHandler(e);
  };
  const displayAutoCompleteFabricList = () => {
    props.displayAutoCompleteFabricList();
  };

  const fabricColourEnterKeyEventHandler = (e) => {
    props.fabricColourEnterKeyEventHandler(e);
  };
  const displayAutoCompleteFabricColorList = () => {
    props.displayAutoCompleteFabricColorList();
  };
  return (
    <div>
      <Row className="d-flex justify-content-left">
        <Col sm="1">
          {" "}
          {props.is3PL ? (
            <FormLabel>Item</FormLabel>
          ) : (
            <FormLabel>FabricStyle</FormLabel>
          )}
        </Col>
        <Col sm="2">
          <InputTextbox
            onChange={fabricCodeOnChange}
            ref={fabricCodeRef}
            name="fabricStyleCode"
            placeholder={props.is3PL ? "Item" : "FabricStyle"}
            value={criteria.fabricStyleCode}
            lookupRequired={props.isFabricLookup}
            lookupHandler={fabricLookupHandler}
            showCriteriaDialog={true}
            enterKeyEventHandler={fabricEnterKeyEventHandler}
            autoCompleteListData={props.fabricPageListForAutoCompleteList}
            enableAutoCompleteTextBox={true}
            displayAutoCompleteList={displayAutoCompleteFabricList}
            showAutoCompleteList={props.showAutoCompleteFabricList}
            disabled={props.isDisable}
            isMandatory={true}
          />
        </Col>
        <Col sm="2">
          <InputTextbox
            onChange={onChange}
            name="fabricStyleName"
            placeholder={props.is3PL ? "ItemName" : "FabricStyleName"}
            value={criteria.fabricStyleName}
            disabled={true}
          />
        </Col>
        <Col sm="1">
          {" "}
          <FormLabel>ColorCode</FormLabel>
        </Col>
        <Col sm="2">
          <InputTextbox
            onChange={onFabricColourCodeChange}
            ref={colorCodeRef}
            name="fabricStyleColorCode"
            placeholder="Color"
            value={criteria.fabricStyleColorCode}
            lookupRequired={props.isShowColorLookup}
            lookupHandler={props.colorLookupHandler}
            enterKeyEventHandler={fabricColourEnterKeyEventHandler}
            autoCompleteListData={props.fabricColourPageListForAutoCompleteList}
            enableAutoCompleteTextBox={true}
            displayAutoCompleteList={displayAutoCompleteFabricColorList}
            showAutoCompleteList={props.showAutoCompleteFabricColorList}
            disabled={props.isDisable}
          />
        </Col>
      </Row>
    </div>
  );
}
function FabricWeeklyMonthlyATSInquiry(props) {
  return (
    <div id="moduleContainer" class="module_container">
      <div id="app_container"></div>
      <FabricWeeklyInquiryModule {...props} name="" /> <br />
    </div>
  );
}

export default FabricWeeklyMonthlyATSInquiry;
